// constant/index.js

import Vue from 'vue'
import Enum from './enum'
import EnumModule from './module'

Vue.use(Enum, EnumModule)


// WEBPACK FOOTER //
// ./src/constant/index.js